/**
 * Classroom live classes API – all endpoints used by classroom live classes management.
 * Base path: /admin/classroom (classroom live classes routes mounted in backend organization routes).
 *
 * All endpoints return the standard shape:
 * - Success: { success: true, statusCode, message, data }
 * - Error: thrown with message from backend (response: { success: false, statusCode, message, error: { message } })
 * Use response.data for payload (e.g. response.data.liveClasses, response.data.pagination, response.data.zoom_start_url).
 */
import {
  DELETE,
  POST,
  PUT,
} from "../../apiController";

const CLASSROOM_LIVECLASSES = '/admin/classroom';

// ==================== ZOOM LIVE CLASSES ====================

// Create a new live class with Zoom meeting
export const createZoomLiveClass = (data) => {
  return POST(`${CLASSROOM_LIVECLASSES}/zoom_live_class`, data);
};

// Get all live classes for a classroom
export const getZoomLiveClasses = (data) => {
  return POST(`${CLASSROOM_LIVECLASSES}/zoom_live_classes`, data);
};

export const getClassroomLiveClassById = (data) => {
  return POST(`${CLASSROOM_LIVECLASSES}/live_class/details`, data);
};

// Update a live class
export const updateZoomLiveClass = (liveClassId, data) => {
  return PUT(`${CLASSROOM_LIVECLASSES}/zoom_live_class/${liveClassId}`, data);
};

// Delete a live class
export const deleteZoomLiveClass = (liveClassId) => {
  return DELETE(`${CLASSROOM_LIVECLASSES}/zoom_live_class/${liveClassId}`);
};

// Start a live class meeting
export const startZoomLiveClass = (data) => {
  return POST(`${CLASSROOM_LIVECLASSES}/zoom_live_class/start`, data);
};

// End a live class meeting
export const endZoomLiveClass = (data) => {
  return POST(`${CLASSROOM_LIVECLASSES}/zoom_live_class/end`, data);
};

// Generate join token for trainee
export const generateJoinToken = (data) => {
  return POST(`${CLASSROOM_LIVECLASSES}/zoom_live_class/join_token`, data);
};

// ==================== LEGACY LIVE CLASSES ====================

// Create live class
export const createLiveClass = (data) => {
  return POST(`${CLASSROOM_LIVECLASSES}/create_live_class`, data);
};

// Get all live classes
export const getLiveClasses = (data) => {
  return POST(`${CLASSROOM_LIVECLASSES}/get_live_classes`, data);
};

// Start live class
export const startLiveClass = (data) => {
  return POST(`${CLASSROOM_LIVECLASSES}/start_live_class`, data);
};

// End live class
export const endLiveClass = (data) => {
  return POST(`${CLASSROOM_LIVECLASSES}/end_live_class`, data);
};

// Delete live class
export const deleteLiveClass = (data) => {
  return POST(`${CLASSROOM_LIVECLASSES}/delete_live_class`, data);
};

// Update live class
export const updateLiveClass = (data) => {
  return PUT(`${CLASSROOM_LIVECLASSES}/update-live-class`, data);
};
